import React, { useState, useEffect } from 'react';
import { MenuContext } from './DataContext';
import axios from "axios";
import slugify from 'react-slugify';
import config from '../components/configuration/config';

export const MenuState = ({ children }) => {
    let langdefault = 'es'
    const [menuLang, setMenuLang] = useState(langdefault);

    const menuURL = 'https://apievt.lacnic.net/wp-json/menus/v1/menus';

    const eventSlug = config.REACT_APP_EVENT_SLUG;
    const eventName = slugify(eventSlug);

    const [isMenu, setMenu] = useState([])
    const [loading, setLoadApiMenuData] = useState(false)
    const [menuError, setMenuError] = useState(null)

    useEffect(() => { 
        const loadOurEvents = async () => {
            if (!menuLang) {
                return;
            }
            setLoadApiMenuData(true) 
            try {
                const responseJSON = await axios.get(`${menuURL}/${eventName}-${menuLang}`)
                setMenu(responseJSON.data)
                setMenuError(null)
            } catch (error) {
                console.error("Error loading menu:", error);
                setMenu([]) // Set empty menu on error
                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    const wpMenuUrl = config.menuEditorURL;
                    setMenuError({
                        message: `No encontramos el menú "${eventName}-${menuLang}". Creá este menú en WordPress para continuar.`,
                        links: [
                            {
                                href: wpMenuUrl,
                                label: 'Abrir editor de menús en WordPress',
                            },
                        ],
                    });
                } else {
                    setMenuError({
                        message: 'No pudimos cargar el menú del evento. Intenta nuevamente o verifica la configuración.',
                        links: [],
                    });
                }
            } finally {
                setLoadApiMenuData(false)
            }
        }
        loadOurEvents()
    }, [menuURL, menuLang, eventName])
    
    const handleMenuLang = (value) => {
        setMenuLang(value)
    }
    
    const [eventID, setEventID] = useState(157);
    const eventURL = 'https://apievt.lacnic.net/wp-json/wp/v2/our_events';

    const [id, setID] = useState([])
 

    useEffect(() => {
        const loadEvent = async () => {
            try {
                const responseJSON = await axios.get(`${eventURL}/${eventID}`)
                setID(responseJSON.data.id)
            } catch (error) {
                console.error("Error loading event:", error);
                setID(null) // Set ID to null on error
            }
        }
        loadEvent();
    }, [eventURL, eventID])

    const handleEventID = (event_value) => {
        setEventID(event_value)
    }

    // Menú app en Headstuff
    const [isMenuApp, setMenuApp] = useState([])
    const [isLoadMenuApp, setLoadMenuApp] = useState(false)
    const [menuAppAvailable, setMenuAppAvailable] = useState(false)

    // Función para verificar si el menú de la app debe cargarse
    const shouldLoadAppMenu = () => {
        // Verifica si existe una configuración para usar el menú de la app
        if (config.useAppMenu === false) {
            return false;
        } 
        // Aquí puedes añadir más lógica si es necesario
        // Por ejemplo, verificar si estamos en un evento específico que usa el menú de la app 
        return true;
    }

    useEffect(() => { 
        const loadAppMenu = async () => {
            if (!menuLang || !shouldLoadAppMenu()) {
                setMenuApp([]);
                setMenuAppAvailable(false);
                return;
            }

            setLoadMenuApp(true);
            try {
                const response = await axios.get(`${menuURL}/${eventName}-app-${menuLang}`);
                if (response.data && response.data.items && response.data.items.length > 0) {
                    setMenuApp(response.data);
                    setMenuAppAvailable(true);
                } else {
                    setMenuApp([]);
                    setMenuAppAvailable(false);
                }
            } catch (error) {
                console.log("App menu not available or error occurred");
                setMenuApp([]);
                setMenuAppAvailable(false);
            } finally {
                setLoadMenuApp(false);
            }
        };

        loadAppMenu();
    }, [menuURL, menuLang, eventName]);
 

     
    return (
        <MenuContext.Provider value={{
            handleMenuLang, 
            handleEventID, 
            isMenu, 
            menuLang, 
            id, 
            loading, 
            eventID, 
            isLoadMenuApp, 
            isMenuApp,
            menuAppAvailable,
            menuError
        }}>
            {children}
        </MenuContext.Provider>
    );
}